module.exports = __webpack_public_path__ + "img/dummy-accred-photo-1.275a3eec.png";